import { lazy } from 'react';

import { formOpts } from '#form';

import {
	QuestionnaireDetails,
	SeasonalityPeriod,
} from '@repo/api/claim/questionnaire.types';
import { fixTime, padTime } from '@repo/ui/utils/dateTime';

export const defaultValues: QuestionnaireDetails = {
	ein: undefined,
	businessOperationDescription: undefined,
	// openingTime: undefined,
	// closingTime: undefined,
	businessOperationLessThan12Months: undefined,
	businessOperationAsOfOIncidentDateTimeType: undefined,
	businessOperationAsOfOIncidentNumber: undefined,
	isBusinessEndOfYearFiscal: undefined,
	fiscalMonth: undefined,
	majorChangesToBusinessPriorToLoss: undefined,
	businessClosedDays: undefined,
	businessSeasonality: undefined,
	customersCreditCardsAccepted: undefined,
	rebuildNeeded: undefined,
	generalImpactDescription: undefined,
	incidentTime: undefined,
	operationsShutDown: undefined,

	managerPayrollContinued: undefined,
	managerContinuingWagePercent: undefined,
	nonManagerPayrollContinued: undefined,
	nonManagerContinuingWagePercent: undefined,
	ownersPayrollOnFinancialStatement: undefined,
	ownersPayrollOnFinancialStatementPercent: undefined,

	employeeTippedWages: undefined,
	openingClosingTimes: [],
};

export type Page = 'details' | 'loss' | 'payroll';

export const fieldPages: Record<keyof QuestionnaireDetails, Page> = {
	ein: 'details',
	naicsCodeId: 'details',
	businessOperationDescription: 'details',
	// allDay: 'details',
	// openingTime: 'details',
	// closingTime: 'details',
	openingClosingTimes: 'details',
	businessOperationLessThan12Months: 'details',
	businessOperationAsOfOIncidentDateTimeType: 'details',
	businessOperationAsOfOIncidentNumber: 'details',
	isBusinessEndOfYearFiscal: 'details',
	fiscalMonth: 'details',
	majorChangesToBusinessPriorToLoss: 'details',
	businessClosedDays: 'details',
	businessSeasonality: 'details',
	customersCreditCardsAccepted: 'details',
	generalImpactDescription: 'loss',
	incidentTime: 'loss',
	operationsShutDown: 'loss',
	rebuildNeeded: 'loss',

	managerPayrollContinued: 'payroll',
	managerContinuingWagePercent: 'payroll',
	nonManagerPayrollContinued: 'payroll',
	nonManagerContinuingWagePercent: 'payroll',
	ownersPayrollOnFinancialStatement: 'payroll',
	ownersPayrollOnFinancialStatementPercent: 'payroll',
	ownersCompensationIncludedOnFinancialStatements: 'payroll',

	employeeTippedWages: 'payroll',
} as const;

export function isValidPage(page: string): page is Page {
	return ['details', 'loss', 'payroll'].includes(page);
}

export const pageTitles: { [key in Page]: string } = {
	details: 'Normal Business Operations',
	loss: 'Loss Event',
	payroll: 'Payroll',
};

export function fixData(value: QuestionnaireDetails): QuestionnaireDetails {
	return {
		...value,
		// openingTime: fixTime(value.openingTime),
		// closingTime: fixTime(value.closingTime),
		incidentTime: fixTime(value.incidentTime),
	};
}

export function postData(value: QuestionnaireDetails): QuestionnaireDetails {
	return {
		...value,
		// openingTime: value.allDay === true ? null : padTime(value.openingTime),
		// closingTime: value.allDay === true ? null : padTime(value.closingTime),
		incidentTime: padTime(value.incidentTime),
		businessOperationAsOfOIncidentNumber:
			value.businessOperationLessThan12Months ?
				value.businessOperationAsOfOIncidentNumber
			:	null,
		businessOperationAsOfOIncidentDateTimeType:
			value.businessOperationLessThan12Months ?
				(value.businessOperationAsOfOIncidentDateTimeType ?? 2)
			:	null,
		fiscalMonth: value.isBusinessEndOfYearFiscal ? value.fiscalMonth : null,
		// Strip temporary _key fields used for React keys
		businessSeasonality: value.businessSeasonality?.map(
			({ _key, ...entry }: SeasonalityPeriod & { _key?: string }) => entry,
		),
	};
}

export const questionnaireOpts = formOpts<QuestionnaireDetails>();

export const BQForm = lazy(() => import('./BQForm'));
